if(typeof window.CookieConsent !== 'undefined') {
	/*global cc_obj */
	var curLang = ( typeof cc_obj === 'undefined' ) ? 'en' : ( ( ['en', 'de', 'nl', 'fi', 'pl', 'fr', 'it'].indexOf(cc_obj.lang) < 0 ) ? curLang = 'en' : cc_obj.lang );
	window.CookieConsent.init({
		language: {
			current: curLang,
			locale: {
				en: {
					barMainTitle: 'This website uses cookies',
					barMainText: 'Our website uses cookies to improve your experience, to analyze our traffic, and for marketing purposes when allowed by you. You can read more about how we use cookies in our Cookie Page.',
					barLinkSetting: 'Manage settings',
					barBtnAcceptAll: 'Accept all',
					modalMainTitle: 'Manage cookies',
					modalMainText: 'Our website uses cookies, which are small text files that are stored on your computer or mobile device when you visit us. They are used to improve your experience on our page.\n\nYou can find out more details about easee\'s approach to privacy by reading our Privacy Policy.',
					modalBtnSave: 'Save settings',
					modalBtnAcceptAll: 'Accept all',
					//modalAffectedSolutions: 'Affected solutions:',
					//learnMore: 'Learn More',
					on: 'On',
					off: 'Off',
				},
				it: {
					barMainTitle: 'Questo sito web utilizza i cookie',
					barMainText: 'Il nostro sito utilizza i cookie per offrire all’utente la migliore esperienza di navigazione, per analizzare il nostro traffico e per finalità di marketing, purché l’utente abbia dato il suo consenso in tal senso. Maggiori informazioni sul modo in cui utilizziamo i cookie sono disponibili alla pagina Cookie Page.',
					barLinkSetting: 'Gestire le impostazioni',
					barBtnAcceptAll: 'Accetta tutti',
					modalMainTitle: 'Gestire le impostazioni',
					modalMainText: 'Il nostro sito utilizza i cookie, che sono piccoli file di testo che vengono memorizzati sul computer o sul dispositivo mobile quando visita il sito e che servono per migliorare l’esperienza di navigazione della nostra pagina.',
					modalBtnSave: 'Salva le impostazioni',
					modalBtnAcceptAll: 'Accetta tutti',
					//modalAffectedSolutions: 'Affected solutions:',
					//learnMore: 'Learn More',
					on: 'On',
					off: 'Off',
				},
				de: {
					barMainTitle: 'Diese Website verwendet Cookies',
					barMainText: 'Unsere Website verwendet Cookies, um Ihre Erfahrungen zu verbessern, um unseren Verkehr zu analysieren und für Marketingzwecke, wenn Sie dies erlauben. Auf unserer Cookie Seite können Sie mehr darüber erfahren, wie wie Cookies verwenden.',
					barLinkSetting: 'Einstellungen verwalten',
					barBtnAcceptAll: 'Alles akzeptieren',
					modalMainTitle: 'Cookies verwalten',
					modalMainText: 'Unsere Website verwendet Cookies, d.h. kleine Textdateien, die auf Ihrem Computer oder Mobilgerät gespeichert sind, wenn Sie unsere Website besuchen, und um Ihre Erfahrung auf unserer Seite zu verbessern.\n\nWeitere Details zum Datenschutz bei easee finden Sie in unseren Datenschutzrichtlinien.',
					modalBtnSave: 'Einstellungen speichern',
					modalBtnAcceptAll: 'Alles akzeptieren',
					//modalAffectedSolutions: 'Affected solutions:',
					//learnMore: 'Learn More',
					on: 'On',
					off: 'Off',
				},
				nl: {
					barMainTitle: 'Deze website gebruikt cookies',
					barMainText: 'Onze website maakt gebruik van cookies om je ervaring te verbeteren, het verkeer op onze website te analyseren, en voor marketingdoeleinden, als je dit toestaat. Op onze Cookie-pagina kun je meer lezen over hoe we met cookies omgaan.',
					barLinkSetting: 'Beheer instellingen',
					barBtnAcceptAll: 'Accepteer alle',
					modalMainTitle: 'Beheer instellingen',
					modalMainText: 'Onze website maakt gebruik van cookies. Dit zijn kleine tekstbestanden die op je computer of mobiele apparaat worden opgeslagen wanneer je onze website bezoekt, en die worden gebruikt om je ervaring op onze pagina te verbeteren.\n\nIn ons Privacybeleid kan je meer informatie vinden over easee\'s privacy-aanpak. ',
					modalBtnSave: 'Instellingen opslaan',
					modalBtnAcceptAll: 'Accepteer alle',
					//modalAffectedSolutions: 'Affected solutions:',
					//learnMore: 'Learn More',
					on: 'On',
					off: 'Off',
				},
				fi: {
					barMainTitle: 'Tämä sivusto käyttää evästeitä',
					barMainText: 'Sallitessasi evästeet, verkkosivustomme käyttää niitä käyttökokemuksen parantamiseksi, verkkoliikenteen analysoimiseksi ja markkinointitarkoituksiin. Voit lukea lisää kuinka käytämme evästeitä Eväste-sivultamme.',
					barLinkSetting: 'Hallitse asetuksia',
					barBtnAcceptAll: 'Hyväksy kaikki',
					modalMainTitle: 'Hallitse evästeitä',
					modalMainText: 'Sivustomme käyttää evästeitä. Evästeet ovat pieniä tekstitiedostoja, jotka tallentuvat tietoneellesi tai mobiililaitteellesi kun vierailet sivustollamme. Niitä käytetään parantamaan kokemustasi sivullamme.\n\nLöydät lisätietoja easee:n lähestymistavasta käyttäjien yksityisyyteen lukemalla tietosuojakäytäntömme.',
					modalBtnSave: 'Tallenna asetukset',
					modalBtnAcceptAll: 'Hyväksy kaikki',
					//modalAffectedSolutions: 'Affected solutions:',
					//learnMore: 'Learn More',
					on: 'On',
					off: 'Off',
				},
				pl: {
					barMainTitle: 'Ta strona używa plików cookies',
					barMainText: 'Nasza strona internetowa korzysta z plików cookies, aby poprawić Twoje doświadczenia, analizować nasz ruch oraz, jeśli się na to zdecydujesz, również w celach marketingowych. Więcej o tym, jak używamy plików cookies, możesz przeczytać na naszej witrynie cookie.',
					barLinkSetting: 'Zarządzaj ustawieniami ',
					barBtnAcceptAll: 'Akceptuj wszystkie',
					modalMainTitle: 'Zarządzaj plikami cookies',
					modalMainText: 'Nasza strona internetowa używa plików cookies, czyli małych plików tekstowych, które przechowywane są na Twoim komputerze lub urządzeniu mobilnym, kiedy nas odwiedzasz, w celu poprawy jakości korzystania z naszej witryny.\n\nWięcej informacji na temat podejścia easee do ochrony prywatności możesz znaleźć w naszej Polityce prywatności.',
					modalBtnSave: 'Zapisz ustawienia',
					modalBtnAcceptAll: 'Akceptuj wszystkie',
					//modalAffectedSolutions: 'Affected solutions:',
					//learnMore: 'Learn More',
					on: 'On',
					off: 'Off',
				},
				fr: {
					barMainTitle: 'Ce site web utilise des cookies',
					barMainText: 'Notre site utilise des cookies afin de vous permettre une expérience optimale, nous permettre d\'analyser le trafic du site web et à des fins de marketing lorsque vous l\'autorisez. Vous pourrez accéder à toutes les informations autour de notre utilisation de cookies sur notre page "cookies".',
					barLinkSetting: 'Gérer les paramètres',
					barBtnAcceptAll: 'Tout accepter',
					modalMainTitle: 'Gérer les cookies',
					modalMainText: 'Notre site utilise des cookies - des petits fichiers texte stockés dans votre ordinateur ou votre portable lorsque vous vous rendez sur notre site, et utilisés dans le but d\'optimiser votre expérience du site web.\n\nToutes les informations autour des démarches d\'easee quant à votre confidentialité se trouvent dans notre Politique de Confidentialité.',
					modalBtnSave: 'Se souvenir de ces paramètres',
					modalBtnAcceptAll: 'Tout accepter',
					//modalAffectedSolutions: 'Affected solutions:',
					//learnMore: 'Learn More',
					on: 'On',
					off: 'Off',
				},
			},
		},
		theme: {
			barColor: '#ff918c',
			barTextColor: '#000',
			barMainButtonColor: '#ff918c',
			barMainButtonTextColor: '#000',
			modalMainButtonColor: '#ff918c',
			modalMainButtonTextColor: '#000',
		},
		categories: {
			necessary: {
				needed: true,
				wanted: true,
				checked: true,
				language: {
					locale: {
						en: {
							name: 'Necessary',
							description: 'These cookies are necessary for the website to function and cannot be switched off. Our necessary cookies are used, for example, to help us to enable and support our security features and to identify trusted web traffic.',
						},
						it: {
							name: 'Cookie necessari',
							description: 'Questi cookie sono necessari per il funzionamento del sito e non possono essere disattivati. I nostri cookie necessari servono, ad esempio, per aiutarci ad abilitare e supportare le funzionalità di sicurezza e per identificare il traffico web attendibile.',
						},
						de: {
							name: 'Notwendig',
							description: 'Diese Cookies sind für das Funktionieren der Website notwendig und können nicht abgeschaltet werden. Unsere notwendigen Cookies helfen uns z. B. dabei, unsere Sicherheitsfunktionen zu aktivieren und zu unterstützen sowie vertrauenswürdigen Webverkehr zu identifizieren.',
						},
						nl: {
							name: 'Noodzakelijk',
							description: 'Deze cookies zijn noodzakelijk voor het functioneren van de website en kunnen niet worden uitgezet. Onze noodzakelijke cookies worden bijvoorbeeld gebruikt om ons te helpen onze beveiligingsfuncties in te schakelen en te ondersteunen, en om vertrouwd webverkeer te identificeren.',
						},
						fi: {
							name: 'Välttämätön',
							description: 'Nämä evästeet ovat välttämättömiä verkkosivustomme toiminnalle, eikä niitä voi poistaa käytöstä. Tarvittavia evästeitä käytetään esimerkiksi auttamaan meitä ottamaan käyttöön ja tukemaan turvallisuusominaisuuksia ja tunnistamaan luotettavaksi luokiteltu verkkoliikenne.',
						},
						pl: {
							name: 'Niezbędne',
							description: 'Te pliki cookies są niezbędne do działania witryny i nie można ich wyłączyć. Są one używane na przykład, aby pomóc nam włączyć i wspierać funkcje bezpieczeństwa oraz zidentyfikować zaufany ruch internetowy.',
						},
						fr: {
							name: 'Indispensable / Nécessaire',
							description: 'Ces cookies sont indispensables au bon fonctionnement du site et ne peuvent pas être désactivés. Les cookies indispensables sont utilisés, par exemple, dans le cadre de nos fonctions de sécurité et la détection d\'un trafic de confiance sur le site web.',
						},
					},
				},
			},
			analytical: {
				needed: false,
				wanted: false,
				checked: false,
				language: {
					locale: {
						en: {
							name: 'Analytical',
							description: 'We use third-party analysis and tracking services, which helps us to understand the usage of the website by you. You can withdraw your consent to this processing at any time, like, for example, disabling cookies on your browser.',
						},
						it: {
							name: 'Cookie analitici',
							description: 'Ci avvaliamo di terzi per servizi di analisi e di tracciamento, che ci sono utili per comprendere in che modo l’utente utilizzi il nostro sito. L’utente può revocare il consenso a tale modus operandi in qualunque momento, ad esempio disattivando i cookie sul proprio browser.',
						},
						de: {
							name: 'Analytisch',
							description: 'Wir verwenden Analyse- und Tracking-Dienste, die uns helfen, die Nutzung der Website durch Sie zu verstehen. Sie können Ihre Zustimmung zu dieser Verarbeitung jederzeit widerrufen, wie z. B. durch Deaktivierung von Cookies in Ihrem Browser.',
						},
						nl: {
							name: 'Analytisch',
							description: 'Wij maken gebruik van analyse- en traceringsdiensten van derden, die ons helpen inzicht te krijgen in jouw gebruik van onze website. Je kunt je toestemming voor deze verwerking te allen tijde intrekken, door bijvoorbeeld cookies in je browser uit te schakelen.',
						},
						fi: {
							name: 'Analyyttinen',
							description: 'Käytämme kolmansien osapuolten analyysi- ja seurantapalveluja, jotka auttavat meitä ymmärtämään miten käytät verkkosivustoamme. Voit milloin tahansa peruuttaa suostumuksesi tähän käsittelyyn, kuten esimerkiksi poistamalla evästeiden käytön selaimestasi.',
						},
						pl: {
							name: 'Analityczne',
							description: 'Korzystamy z usług analizy i śledzenia oferowanych przez strony trzecie, które pomagają nam zrozumieć Twój sposób korzystania z witryny. W każdej chwili możesz cofnąć zgodę na to przetwarzanie - na przykład poprzez wyłączenie obsługi plików cookies w swojej przeglądarce.',
						},
						fr: {
							name: 'Analytiques',
							description: 'Nous utilisons un système électronique d\'analyse et de surveillance auprès d\'une partie tierce, qui nous permet de mieux comprendre votre utilisation du site web. Vous pouvez retirer votre consentement au traitement de ces données à tout moment, en désactivant les cookies de votre navigateur web par exemple.',
						},
					},
				},
			},
			preferences: {
				needed: false,
				wanted: false,
				checked: false,
				language: {
					locale: {
						en: {
							name: 'Preferences',
							description: 'We use these cookies so that we recognize you on our website and remember your previously selected preferences. These could include what language you prefer and location you are in. You can withdraw your consent to this processing at any time, like, for example, disabling cookies on your browser.',
						},
						it: {
							name: 'Cookie di preferenza',
							description: 'Utilizziamo questi cookie per riconoscere l’utente quando visita il nostro sito e ricordare le preferenze espresse in occasione di precedenti visite. Queste possono comprendere la lingua di navigazione e il luogo di provenienza. L’utente può revocare il consenso a tale modus operandi in qualunque momento, ad esempio disattivando i cookie sul proprio browser.',
						},
						de: {
							name: 'Präferenzen',
							description: 'Wir verwenden diese Cookies, damit wir Sie auf unserer Website wiedererkennen und uns Ihre zuvor gewählten Einstellungen merken. Beispielsweise, welche Sprache Sie bevorzugen und wo Sie sich aufhalten. Sie können Ihre Zustimmung zu dieser Verarbeitung jederzeit widerrufen, wie z. B. durch die Deaktivierung von Cookies in Ihrem Browser.',
						},
						nl: {
							name: 'Voorkeuren',
							description: 'Wij gebruiken deze cookies zodat wij je op onze website kunnen herkennen en je eerder gekozen voorkeuren kunnen onthouden. Denk hierbij aan welke taal je voorkeur heeft en wat je locatie is. Je kunt je toestemming voor deze verwerking te allen tijde intrekken, door bijvoorbeeld cookies in je browser uit te schakelen.',
						},
						fi: {
							name: 'Preferenssisi',
							description: 'Käytämme näitä evästeitä, jotta voimme tunnistaa sinut verkkosivustollamme ja muistamaan aiemmin valitsemasi asetukset. Nämä voivat sisältää esimerkiksi haluamasi kielen ja sijaintisi. Voit milloin tahansa peruuttaa suostumuksesi tähän käsittelyyn, kuten esimerkiksi poistamalla evästeiden käytön selaimestasi.',
						},
						pl: {
							name: 'Preferencje',
							description: 'Używamy wspomnianych plików cookies, aby rozpoznać Cię na naszej stronie internetowej i zapamiętać Twoje wcześniej wybrane preferencje. Mogą one obejmować preferowany język i lokalizację. Możesz wycofać swoją zgodę na to przetwarzanie w dowolnym momencie, na przykład wyłączając pliki cookies w swojej przeglądarce.',
						},
						fr: {
							name: 'Préférences',
							description: 'Nous utilisons ces cookies afin de vous reconnaître sur notre site web et nous souvenir des préférences d\'utilisation séléctionnées lors de votre utilisation précédente. Ces préférences peuvent comprendre la langue choisie et la situation géographique. Vous pouvez retirer votre consentement au traitement de ces données à tout moment, en désactivant les cookies de votre navigateur web par exemple.',
						},
					},
				},
			},
			marketing: {
				needed: false,
				wanted: false,
				checked: false,
				language: {
					locale: {
						en: {
							name: 'Marketing',
							description: 'We use these cookies to collect information about your visit to our website, the content you viewed, the links you followed and information about your browser, device, and your IP address. We may also share online data collected through cookies with our advertising partners. This means that when you visit another website, you may be shown advertising based on your browsing patterns on our website. You can withdraw your consent to this processing at any time, like, for example, disabling cookies on your browser.',
						},
						it: {
							name: 'Cookie di marketing',
							description: 'Utilizziamo questi cookie per acquisire informazioni sulla visita dell’utente al nostro sito, le pagine visitate e i link seguiti, come anche informazioni riguardanti il browser e il dispositivo utilizzato, oltre all’indirizzo IP. Possiamo anche condividere i dati online raccolti tramite i cookie con i partner pubblicitari.Questo significa che quando l’utente visita un altro sito, gli possono essere mostrati annunci sulla base dei modelli di navigazione messi in atto durante la visita del nostro sito. L’utente può revocare il consenso a tale modus operandi in qualunque momento, ad esempio disattivando i cookie sul proprio browser.',
						},
						de: {
							name: 'Marketing',
							description: 'Wir verwenden diese Cookies, um Informationen über Ihren Besuch auf unserer Website, die Inhalte, die Sie angesehen haben, die Links, denen Sie gefolgt sind und Informationen über Ihren Browser, Ihr Gerät und Ihre IP-Adresse zu sammeln. Wir können auch Online-Daten, die durch Cookies gesammelt wurden, mit unseren Werbepartnern teilen. Das bedeutet, dass Sie beim Besuch einer anderen Website möglicherweise Werbung angezeigt bekommen, die auf Ihr Surfverhalten auf unserer Website zurückzuführen sind. Sie können Ihre Zustimmung zu dieser Verarbeitung jederzeit widerrufen, indem Sie z.B. die Cookies in Ihrem Browser deaktivieren.',
						},
						nl: {
							name: 'Marketing',
							description: 'Wij gebruiken deze cookies om informatie te verzamelen over je bezoek aan onze website, de inhoud die je hebt bekeken, de links die je hebt gevolgd, en informatie over je browser, apparaat en IP-adres. Het is ook mogelijk dat wij online gegevens, die via cookies zijn verzameld, delen met onze advertentiepartners. Dit betekent dat wanneer je een andere website bezoekt, je reclame te zien krijgt op basis van je browsegedrag op onze website. Je kunt je toestemming voor deze verwerking te allen tijde intrekken, door bijvoorbeeld cookies in je browser uit te schakelen.',
						},
						fi: {
							name: 'Markkinointi',
							description: 'Käytämme näitä evästeitä keräämään tietoa vierailustasi verkkosivustollamme,  tarkastelemastasi sisällöstä ja linkeistä, ja tietoa käyttämästäsi selaimesta, laitteesta sekä IP-osoitteesta. Voimme myös jakaa näitä evästeiden avulla kerättyjä tietoja mainontakumppaneillemme. Tämä tarkoittaa sitä, että kun vierailet toisilla verkkosivustoilla, sinulle voidaan näyttää mainoksia sivustollamme tapahtuneen selauskäyttäytymisesi perusteella. Voit peruuttaa suostumuksesi tähän käsittelyyn milloin tahansa, kuten esimerkiksi poistamalla evästeiden käytön selaimestasi.',
						},
						pl: {
							name: 'Marketing',
							description: 'Używamy tych plików cookies do zbierania informacji o Twoich odwiedzinach na naszej stronie internetowej, przeglądanych treściach, linkach, które kliknąłeś oraz danych Twojej przeglądarki, urządzenia i adresu IP. Możemy również udostępniać informacje zebrane za pomocą plików cookies naszym partnerom reklamowym. Oznacza to, że kiedy odwiedzasz inną witrynę, możesz wyświetlać reklamy oparte na Twoich wzorcach przeglądania na naszej stronie internetowej. W każdej chwili możesz cofnąć zgodę na to przetwarzanie, na przykład wyłączając pliki cookies w przeglądarce.',
						},
						fr: {
							name: 'Marketing',
							description: 'Nous utilisons ces cookies afin de rassembler des informations sur votre visite de notre site web, le contenu visualisé, les liens suivis ainsi que des informations sur votre navigateur, votre appareil électronique et votre adresse IP. Nous pourrions également être amenés à partager des données en ligne collectionées par le biais des cookies auprès de notre partneraire publicitaire. Cela signifie que, lorsque vous vous rendez sur un autre site web, vous pourriez y visualiser des publicités basées sur les recherches que vous avez menées sur notre site web. Vous pouvez retirer votre consentement au traitement de ces données à tout moment, en désactivant les cookies de votre navigateur web par exemple.',
						},
					},
				},
			},
		},
		services: {
			easee: {
				category: 'preferences',
				type: 'wrapped',
				search: 'wrapped',
				language: {
					locale: {
						en: {
							name: 'easee',
						},
						it: {
							name: 'easee',
						},
						de: {
							name: 'easee',
						},
						nl: {
							name: 'easee',
						},
						fi: {
							name: 'easee',
						},
						pl: {
							name: 'easee',
						},
						fr: {
							name: 'easee',
						},
					},
				},
			},
			localcookie: {
				category: 'necessary',
				type: 'localcookie',
				search: 'localcookie',
				language: {
					locale: {
						en: {
							name: 'Local cookie',
						},
						it: {
							name: 'Local cookie',
						},
						de: {
							name: 'Local cookie',
						},
						nl: {
							name: 'Local cookie',
						},
						fi: {
							name: 'Local cookie',
						},
						pl: {
							name: 'Local cookie',
						},
						fr: {
							name: 'Local cookie',
						},
					},
				},
			},
		},
	});
} else {
	console.log('CookieConsent not initiated');
}



// WEBPACK FOOTER //
// ./scripts/cookieconsent-init.js